module.exports = __webpack_public_path__ + "img/ch-101-ei.asm.e3a7f9b1.jpg";